/** The editor's lines: panel borders and dividers, a step above the background. */
export const PANEL_LINE = "neutral.300"
